import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

interface MayaButtonProps {
    children: React.ReactNode;
    variant?: 'jade' | 'turquoise' | 'sun' | 'volcanic' | 'obsidian';
    size?: 'small' | 'medium' | 'large';
    to?: string;
    onClick?: () => void;
    className?: string;
    type?: 'button' | 'submit' | 'reset';
    disabled?: boolean;
    withGlyph?: boolean; /* Para incluir glifos mayas */
}

const MayaButton: React.FC<MayaButtonProps> = ({
   children,
   variant = 'jade',
   size = 'medium',
   to,
   onClick,
   className = '',
   type = 'button',
   disabled = false,
   withGlyph = true,
   ...props
}) => {
    const baseClasses = `maya-button maya-button--${variant} maya-button--${size} ${className}`;

    // Glifos mayas simples para decoración
    const mayaGlyphs = {
        jade: '𓃒',       // Glifo maya estilizado
        turquoise: '𓆇',
        sun: '𓁨',
        volcanic: '𓉡',
        obsidian: '𓊖'
    };

    const buttonContent = (
        <motion.span
            className="maya-button__content"
            whileHover={!disabled ? { scale: 1.05, y: -2 } : {}}
            whileTap={!disabled ? { scale: 0.95 } : {}}
        >
            {withGlyph && (
                <span className="maya-button__glyph">
                  {mayaGlyphs[variant]}
                </span>
            )}
            {children}
            <span className="maya-button__text">{children}</span>
            <span className="maya-button__glow"></span>
            <span className="maya-button__border"></span>
            <span className="maya-button__pattern"></span> {/* Patrón geométrico maya */}
        </motion.span>
    );

    if (to) {
        return (
            <Link to={to} className={baseClasses} {...props}>
                {buttonContent}
            </Link>
        );
    }

    return (
        <motion.button
            className={baseClasses}
            onClick={onClick}
            type={type}
            disabled={disabled}
            whileHover={!disabled ? { scale: 1.02 } : {}}
            whileTap={!disabled ? { scale: 0.98 } : {}}
            {...props}
        >
            {buttonContent}
        </motion.button>
    );
};

export default MayaButton;